import { FC } from 'react';
import { IOrderForClient } from 'src/models/IOrder';
import './styles.scss';

interface IProps {
  order: IOrderForClient;
}

const PickupInfoCard: FC<IProps> = ({ order }) => {
  const {
    location,
    end_location,
    pickUpAddress,
    pickUpDetails,
    dropAddress,
    dropDetails,
    delivery_address,
    return_at
  } = order;

  return (
    <div className='pickup-card'>
      <div className='client__order__main__header'>
        <div>
          <h4>Where do I get my van?</h4>
          <h6>Address are pick-up & drop-off locations only.</h6>
        </div>
      </div>
      {pickUpDetails || delivery_address || dropDetails || return_at ? (
        <>
          {(pickUpDetails || delivery_address) && (
            <div className='pickup-card__wrapper'>
              <div className='pickup-card__container'>
                <img src='../images/start-location.png' alt='start-location' />
                <div>
                  <div className='pickup-card__subtitle'>Start Location</div>
                  <h5>{location}</h5>
                </div>
              </div>
              <p>{delivery_address ? delivery_address : pickUpAddress}</p>
              {!delivery_address && (
                <div className='pickup-card__info'>
                  <div className='pickup-card__subtitle'>pickup info</div>
                  <p>{pickUpDetails}</p>
                </div>
              )}
            </div>
          )}
          {(dropDetails || return_at) && (
            <div className='pickup-card__wrapper'>
              <div className='pickup-card__container'>
                <img src='../images/end-location.png' alt='end-location' />
                <div>
                  <div className='pickup-card__subtitle'>End Location</div>
                  <h5>{end_location ? end_location : location}</h5>
                </div>
              </div>
              <p>{return_at ? return_at : dropAddress}</p>
              {!return_at && (
                <div className='pickup-card__info'>
                  <div className='pickup-card__subtitle'>drop-off info</div>
                  <p>{dropDetails}</p>
                </div>
              )}
            </div>
          )}
        </>
      ) : (
        <h5>Please contact the host to confirm pick-up and drop-off addresses.</h5>
      )}
    </div>
  );
};

export default PickupInfoCard;
